module.exports = __webpack_public_path__ + "assets/img/close-round-white.19b845d2.svg";